var map = {
	"./avatar_operatore.png": "5744",
	"./avatar_wfp.png": "a654",
	"./digital_assistant.png": "83c9",
	"./digital_assistant.svg": "be35",
	"./ico_operatore.png": "d0f6",
	"./ico_premium.png": "620e",
	"./ico_restart.svg": "42c3",
	"./ico_send.svg": "a6c2",
	"./ico_user.png": "f11a",
	"./wfp-icons/arrow.png": "cb3c",
	"./wfp-icons/arrow.svg": "f03b",
	"./wfp-icons/avatar.png": "b161",
	"./wfp-icons/avatar.svg": "8ba8",
	"./wfp-icons/bot.png": "51f6",
	"./wfp-icons/bot.svg": "2056",
	"./wfp-icons/chat.png": "ece5",
	"./wfp-icons/chat.svg": "d542",
	"./wfp-icons/close.png": "afb0",
	"./wfp-icons/close.svg": "6fc8",
	"./wfp-icons/dots.png": "22fd",
	"./wfp-icons/dots.svg": "858d",
	"./wfp-icons/headphones.png": "7066",
	"./wfp-icons/headphones.svg": "13b2",
	"./wfp-icons/microphone.png": "2c35",
	"./wfp-icons/microphone.svg": "f587",
	"./wfp-icons/send.png": "4e82b",
	"./wfp-icons/send.svg": "c927"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0a61";